import axios from 'axios';
import {authService} from "../services/authenticationServiceInstance";
import UtilityService from "../services/utiliyService";

let utilityService= new UtilityService();
// Obtain the fresh token each time the function is called
function getAccessToken(){
    return  authService.getToken();
}
 
// Use interceptor to inject the token to requests
axios.interceptors.request.use(request => {
    if(request.url.indexOf(process.env.VUE_APP_ROOT_API)>=0){
        return getAccessToken().then(token =>{
            request.headers['Authorization'] = `Bearer ${token}`;
            request.headers['Content-Type'] = "application/json";
            request.headers['Http-Section']= utilityService.getDomain();
                return request;
            });
    }
    return request;
});